import React from "react";
import Select from "react-select"; 
import { IOption } from "../interfaces";

// Define the type of the option object

interface IMultiSelectProps {
  options: IOption[];
  className?: string;
  placeholder?: string;
  classNamePrefix?: string;
  selectedOptions: IOption[];
  onChange: (newValues: IOption[]) => void;
}

// Define the type of the selected value
export const MultiSelect = (props: IMultiSelectProps) => {
  return (
    <Select
      // The options array
      options={props.options}
      // The value of the selected value
      value={props.selectedOptions}
      // The handler function for value change
      onChange={(newValue: any) => {
        props.onChange(newValue);
      }}
      // The placeholder text
      placeholder={props.placeholder}
      className={props.className}
      classNamePrefix={props.classNamePrefix || "custom-multi-select"}
      // Enable the multi-select mode
      isMulti
    />
  );
};

export default MultiSelect;
